module.exports = __webpack_public_path__ + "static/img/3_1_4.b0c53901.jpg";